export interface VideoArticle {
  id: string;
  title: string;
  slug: string;
  category: string;
  categoryName: string;
  description: string;
  content: string;
  coverImage: string;
  rating: number;
  year: number;
  duration: string;
  tags: string[];
  publishDate: string;
  viewCount: number;
  isHot: boolean;
  isNew: boolean;
}

export const featuredVideos: VideoArticle[] = [
  {
    id: 'v001',
    title: '流浪地球3',
    slug: 'liu-lang-di-qiu-3',
    category: 'dianying',
    categoryName: '电影',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，人类命运将何去何从？',
    content: '<p>《流浪地球3》延续了前两部的宏大世界观，讲述人类在宇宙中继续寻找新家园的壮丽旅程。本片由郭帆执导，吴京、刘德华等原班人马回归，同时加入多位实力派新演员。</p><p>影片投资超过10亿元，是中国科幻电影史上投资最大的项目。特效团队来自全球顶尖工作室，打造了前所未有的视觉奇观。从黑洞穿越到外星文明，从时间悖论到平行宇宙，影片在硬核科幻基础上融入了深刻的人文思考。</p><p>故事发生在《流浪地球2》之后的50年，地球已经驶出太阳系，进入了全新的星际空间。面对未知的宇宙环境，人类遇到了前所未有的挑战...</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20scene%20with%20spaceship%20and%20giant%20planet%20in%20background%2C%20dramatic%20cinematic%20lighting%20with%20warm%20orange%20and%20cool%20blue%20tones%2C%20futuristic%20technology%2C%20emotional%20human%20figures%20silhouette%2C%20cinematic%20composition%2C%20high%20production%20value%2C%20epic%20scale&width=800&height=450&seq=heitao-v001&orientation=landscape',
    rating: 8.9,
    year: 2026,
    duration: '148分钟',
    tags: ['科幻', '灾难', '国产大片', '吴京'],
    publishDate: '2026-07-20',
    viewCount: 12580000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'v002',
    title: '繁花',
    slug: 'fan-hua',
    category: 'dianshiju',
    categoryName: '电视剧',
    description: '九十年代的上海，处处是机遇与挑战。阿宝凭借自己的智慧和努力，在商海中乘风破浪，谱写了一段传奇人生。',
    content: '<p>《繁花》由王家卫执导，胡歌、马伊琍、唐嫣、辛芷蕾主演，改编自金宇澄同名小说。故事以上世纪九十年代的上海为背景，讲述了一群年轻人在改革开放浪潮中的奋斗与情感故事。</p><p>该剧历时6年打磨，王家卫导演以其独特的视觉美学，将九十年代上海的繁华与时代变迁完美呈现。剧中每一个镜头都如油画般精致，配乐更是请到了多位顶级音乐人操刀。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20at%20night%20with%20neon%20lights%20and%20vintage%20cars%2C%20nostalgic%20atmosphere%2C%20elegant%20Chinese%20drama%20cinematography%20style%2C%20warm%20golden%20tone%2C%20river%20reflection%2C%20artistic%20composition&width=800&height=450&seq=heitao-v002&orientation=landscape',
    rating: 9.3,
    year: 2024,
    duration: '30集',
    tags: ['年代剧', '商战', '沪语', '王家卫'],
    publishDate: '2026-07-18',
    viewCount: 28600000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v003',
    title: '哪吒之魔童闹海',
    slug: 'ne-zha-zhi-mo-tong-nao-hai',
    category: 'dongman',
    categoryName: '动漫',
    description: '天劫之后，哪吒和敖丙的灵魂虽然保住了，但肉身很快就要魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身...',
    content: '<p>《哪吒之魔童闹海》是《哪吒之魔童降世》的续作，由饺子执导。故事紧接前作，哪吒和敖丙在经历天劫后，面临新的挑战。东海龙王为了给儿子报仇，水淹陈塘关，哪吒为保护百姓再次挺身而出。</p><p>影片延续了前作独特的视觉风格，同时在技术和故事深度上都有明显提升。制作团队在角色表情、动作设计上精益求精，打造了一场视觉与情感的盛宴。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20with%20mythological%20warrior%20boy%20with%20fire%20powers%20flying%20above%20ancient%20Chinese%20city%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20dynamic%20action%20pose%2C%20epic%20cinematic%20lighting%2C%20traditional%20Chinese%20aesthetics%20mixed%20with%20modern%203D%20animation&width=800&height=450&seq=heitao-v003&orientation=landscape',
    rating: 8.7,
    year: 2025,
    duration: '130分钟',
    tags: ['动画', '神话', '国产动画', '哪吒'],
    publishDate: '2026-07-15',
    viewCount: 19800000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'v004',
    title: '令人心动的offer 第六季',
    slug: 'ling-ren-xin-dong-de-offer-6',
    category: 'zongyi',
    categoryName: '综艺',
    description: '十位法学专业毕业生进入顶级律师事务所实习，历经重重考验，争夺最终的两个正式offer。',
    content: '<p>《令人心动的offer》第六季重磅回归！本季将聚焦法学领域的精英实习生，他们来自清华、北大、人大、法大等顶尖法学院校，将在国内最负盛名的律师事务所展开为期一个月的实习竞争。</p><p>新一季在赛制和内容上都有重大升级，不仅加入了更多真实案例模拟，还邀请了更多重量级嘉宾作为观察团成员。节目将通过真实的职场场景，展现当代年轻人的奋斗精神和专业素养。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20office%20setting%20with%20young%20Chinese%20professionals%20in%20business%20attire%20working%20collaboratively%2C%20bright%20and%20clean%20corporate%20environment%2C%20warm%20natural%20lighting%2C%20professional%20atmosphere%2C%20reality%20show%20style%20cinematography&width=800&height=450&seq=heitao-v004&orientation=landscape',
    rating: 8.5,
    year: 2026,
    duration: '12期',
    tags: ['职场', '真人秀', '法学', '实习生'],
    publishDate: '2026-07-12',
    viewCount: 8600000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'v005',
    title: '地球脉动 第四季',
    slug: 'di-qiu-mai-dong-4',
    category: 'jilupian',
    categoryName: '纪录片',
    description: 'BBC史诗级自然纪录片回归，以更先进的拍摄技术，展现地球上最壮丽的自然奇观和动物生存故事。',
    content: '<p>《地球脉动》第四季由BBC自然历史部历时5年精心打造，摄制组足迹遍布全球60多个国家和地区，使用最新的8K摄影技术和无人机拍摄，呈现了前所未有的自然奇观。</p><p>本季将深入探索极地冰原、深海世界、热带雨林、沙漠戈壁等极端环境，记录下了许多此前从未被拍摄到的动物行为和自然现象。每一帧画面都堪称艺术品。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20wild%20animals%20in%20savanna%20at%20sunset%2C%20golden%20hour%20light%2C%20dramatic%20sky%2C%20lions%20and%20elephants%20in%20natural%20habitat%2C%20cinematic%20aerial%20photography%2C%20breathtaking%20landscape&width=800&height=450&seq=heitao-v005&orientation=landscape',
    rating: 9.8,
    year: 2026,
    duration: '8集',
    tags: ['自然', '动物', 'BBC', '纪录片'],
    publishDate: '2026-07-10',
    viewCount: 5200000,
    isHot: false,
    isNew: true,
  },
];

export const allVideos: VideoArticle[] = [
  ...featuredVideos,
  {
    id: 'v006',
    title: '庆余年 第三季',
    slug: 'qing-yu-nian-3',
    category: 'dianshiju',
    categoryName: '电视剧',
    description: '范闲在北齐的冒险继续，朝堂风云变幻，各方势力暗流涌动，一场更大的阴谋正在酝酿。',
    content: '<p>《庆余年》第三季重磅回归！张若昀继续饰演范闲，本季将揭晓更多关于神庙的秘密，以及范闲母亲叶轻眉的传奇故事。朝堂之上，庆帝的野心逐渐显露，范闲将面临更加复杂的政治博弈。</p><p>新一季在制作规模和故事格局上都进行了全面升级，更多原著中的经典场景将被搬上荧幕，特效和动作场面也达到了国产剧的新高度。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20court%20scene%20with%20dramatic%20lighting%2C%20warrior%20in%20traditional%20robe%20standing%20in%20grand%20palace%20hall%2C%20atmospheric%20fog%2C%20cinematic%20composition%2C%20historical%20drama%20aesthetic%2C%20warm%20golden%20and%20red%20tones&width=800&height=450&seq=heitao-v006&orientation=landscape',
    rating: 9.1,
    year: 2026,
    duration: '46集',
    tags: ['古装', '权谋', '玄幻', '张若昀'],
    publishDate: '2026-07-08',
    viewCount: 35200000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v007',
    title: '孤注一掷2',
    slug: 'gu-zhu-yi-zhi-2',
    category: 'dianying',
    categoryName: '电影',
    description: '反诈题材续作，聚焦新型网络诈骗手段，讲述警方与诈骗团伙之间的正邪较量。',
    content: '<p>《孤注一掷2》延续了前作的反诈主题，将镜头对准了更加隐蔽和复杂的新型网络诈骗。影片通过多条叙事线索，展现了诈骗团伙的运作内幕以及警方的艰难追捕过程。</p><p>本片在真实案件基础上进行艺术加工，力求以最真实的方式呈现反诈斗争的艰辛。张艺兴、金晨等原班人马回归，同时加入了多位实力派新演员。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Intense%20crime%20thriller%20scene%20in%20Southeast%20Asian%20setting%2C%20dimly%20lit%20room%20with%20computer%20screens%2C%20suspenseful%20atmosphere%2C%20dramatic%20shadows%2C%20modern%20Chinese%20cinema%20aesthetic%2C%20gritty%20realistic%20style&width=800&height=450&seq=heitao-v007&orientation=landscape',
    rating: 8.3,
    year: 2026,
    duration: '135分钟',
    tags: ['犯罪', '反诈', '悬疑', '国产片'],
    publishDate: '2026-07-05',
    viewCount: 15600000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v008',
    title: '咒术回战 第三季',
    slug: 'zhou-shu-hui-zhan-3',
    category: 'dongman',
    categoryName: '动漫',
    description: '涩谷事变之后，咒术界陷入前所未有的混乱。虎杖悠仁和他的伙伴们将面临更加危险的挑战。',
    content: '<p>《咒术回战》第三季将改编原作中备受好评的"死灭回游"篇章。在涩谷事变后，咒术界的格局发生了翻天覆地的变化，虎杖悠仁、伏黑惠和钉崎野蔷薇将面临前所未有的危机。</p><p>MAPPA制作组在本季中投入了更多资源，动作场面的流畅度和视觉冲击力都达到了新高度。音乐方面也请到了多位知名作曲家加盟。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20action%20scene%20with%20young%20warrior%20using%20supernatural%20powers%2C%20dark%20urban%20setting%2C%20dynamic%20energy%20effects%2C%20dramatic%20lighting%2C%20intense%20atmosphere%2C%20high%20quality%20animation%20aesthetic&width=800&height=450&seq=heitao-v008&orientation=landscape',
    rating: 9.0,
    year: 2026,
    duration: '24集',
    tags: ['日漫', '战斗', '热血', 'MAPPA'],
    publishDate: '2026-07-03',
    viewCount: 18200000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'v009',
    title: '奔跑吧 第十四季',
    slug: 'ben-pao-ba-14',
    category: 'zongyi',
    categoryName: '综艺',
    description: '全新一季跑男团集结，更加刺激的游戏挑战，更加爆笑的互动环节，陪你度过欢乐时光。',
    content: '<p>《奔跑吧》第十四季全面升级回归！本季将走访更多国内特色城市，游戏环节设计更加新颖有趣，同时邀请了大量当红明星作为飞行嘉宾参与录制。</p><p>常驻嘉宾阵容也有所调整，既有老成员的回归，也有新鲜血液的加入，必将碰撞出不一样的火花。每一期都充满了欢笑和感动。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20outdoor%20scene%20with%20celebrities%20playing%20fun%20games%20in%20colorful%20setting%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20team%20spirit%2C%20joyful%20expressions%2C%20professional%20broadcast%20quality&width=800&height=450&seq=heitao-v009&orientation=landscape',
    rating: 7.8,
    year: 2026,
    duration: '12期',
    tags: ['户外', '游戏', '明星', '真人秀'],
    publishDate: '2026-07-01',
    viewCount: 9800000,
    isHot: false,
    isNew: true,
  },
  {
    id: 'v010',
    title: '封神第二部',
    slug: 'feng-shen-di-er-bu',
    category: 'dianying',
    categoryName: '电影',
    description: '姜子牙率领众神与殷商大军展开终极对决，封神大战一触即发。',
    content: '<p>《封神第二部》承接第一部的故事，殷寿（纣王）的暴政愈演愈烈，姜子牙联合各路神仙和诸侯，开始了讨伐纣王的征程。宏大的战争场面和精美的特效是本片最大的看点。</p><p>导演乌尔善在第二部中进一步拓展了封神世界的想象空间，将中国传统神话与现代电影技术完美结合，打造了一场视觉盛宴。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%20with%20warriors%20in%20ancient%20armor%2C%20giant%20mythical%20creatures%2C%20dramatic%20sky%20with%20fire%20and%20lightning%2C%20cinematic%20scale%2C%20golden%20and%20crimson%20color%20palette%2C%20blockbuster%20movie%20quality&width=800&height=450&seq=heitao-v010&orientation=landscape',
    rating: 8.6,
    year: 2026,
    duration: '150分钟',
    tags: ['神话', '史诗', '动作', '封神'],
    publishDate: '2026-06-28',
    viewCount: 21000000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v011',
    title: '狂飙2',
    slug: 'kuang-biao-2',
    category: 'dianshiju',
    categoryName: '电视剧',
    description: '扫黑除恶专项斗争持续深入，又一起重大案件浮出水面，正邪较量再度升级。',
    content: '<p>《狂飙2》作为现象级剧集《狂飙》的续作，聚焦全新的扫黑故事。张译、张颂文等原班人马回归，同时加入了一批实力派新演员。故事围绕一起涉及多个领域的重大黑恶势力案件展开。</p><p>本季在保持前作写实风格的基础上，进一步深挖了人性的复杂性，正反两派的心理博弈更加精彩纷呈。编剧团队历时两年打磨剧本，力求呈现一部品质超越前作的精品剧集。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20scene%20in%20modern%20city%20at%20night%2C%20rainy%20street%20with%20police%20car%20lights%2C%20suspenseful%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20gritty%20realistic%20style%2C%20cinematic%20composition&width=800&height=450&seq=heitao-v011&orientation=landscape',
    rating: 9.2,
    year: 2026,
    duration: '40集',
    tags: ['刑侦', '扫黑', '悬疑', '国产剧'],
    publishDate: '2026-06-25',
    viewCount: 42000000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v012',
    title: '中国奇谭 第二季',
    slug: 'zhong-guo-qi-tan-2',
    category: 'dongman',
    categoryName: '动漫',
    description: '八个植根于中国传统文化的独立故事，以全新的动画形式展现中国式奇幻想象。',
    content: '<p>《中国奇谭》第二季延续了第一季的创作理念，邀请了八位不同风格的动画导演，各自创作一个独立短片。每集都取材于中国传统文化元素，通过现代动画手法进行全新演绎。</p><p>本季故事涵盖范围更加广泛，从民间传说到志怪小说，从剪纸艺术到水墨动画，展现了中国动画的多元可能性。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20traditional%20ink%20painting%20aesthetic%2C%20mythical%20creatures%20in%20fantasy%20landscape%2C%20watercolor%20texture%2C%20artistic%20composition%2C%20oriental%20mystical%20atmosphere%2C%20hand-drawn%20animation%20quality&width=800&height=450&seq=heitao-v012&orientation=landscape',
    rating: 9.4,
    year: 2026,
    duration: '8集',
    tags: ['国产动画', '志怪', '短片', '传统文化'],
    publishDate: '2026-06-22',
    viewCount: 7500000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v013',
    title: '风味人间 第五季',
    slug: 'feng-wei-ren-jian-5',
    category: 'jilupian',
    categoryName: '纪录片',
    description: '陈晓卿团队再度出发，探寻全球各地的独特风味，讲述人与食物之间的温暖故事。',
    content: '<p>《风味人间》第五季将镜头对准了世界各地的街头美食和家庭厨房。陈晓卿导演带领团队走访了30多个国家和地区，记录了数百种独特的地方美食及其背后的文化故事。</p><p>本季在保持系列一贯高水准的同时，更加强调了食物与人之间的情感连接。每一道美食背后，都是一个家庭、一个社区、一种文化的缩影。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Delicious%20Chinese%20street%20food%20scene%20with%20steaming%20dishes%20in%20night%20market%2C%20warm%20ambient%20lighting%2C%20colorful%20food%20stalls%2C%20culinary%20documentary%20aesthetic%2C%20mouthwatering%20food%20photography%2C%20cultural%20atmosphere&width=800&height=450&seq=heitao-v013&orientation=landscape',
    rating: 9.5,
    year: 2026,
    duration: '10集',
    tags: ['美食', '人文', '纪录片', '陈晓卿'],
    publishDate: '2026-06-20',
    viewCount: 6800000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v014',
    title: '长安十二时辰2',
    slug: 'chang-an-shi-er-shi-chen-2',
    category: 'dianshiju',
    categoryName: '电视剧',
    description: '盛世长安，暗流涌动。全新的危机在十二时辰内即将爆发，张小敬再度临危受命。',
    content: '<p>《长安十二时辰2》是口碑神作的续集，故事设定在第一部的数年后。长安城中又出现了一起威胁全城安危的阴谋，已经隐退的张小敬不得不再次出山，在十二个时辰内化解这场危机。</p><p>本季在保持前作精良制作水准的同时，在故事深度和人物塑造上更进一步。雷佳音饰演的张小敬更加沉稳老练，新角色也为故事增添了更多变数。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20Chinese%20city%20at%20night%20with%20lanterns%20and%20busy%20streets%2C%20historical%20architecture%2C%20atmospheric%20lighting%2C%20period%20drama%20aesthetic%2C%20mysterious%20suspense%20vibe%2C%20cinematic%20quality&width=800&height=450&seq=heitao-v014&orientation=landscape',
    rating: 8.8,
    year: 2026,
    duration: '36集',
    tags: ['古装', '悬疑', '历史', '雷佳音'],
    publishDate: '2026-06-18',
    viewCount: 16500000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v015',
    title: '这就是街舞 第七季',
    slug: 'zhe-jiu-shi-jie-wu-7',
    category: 'zongyi',
    categoryName: '综艺',
    description: '全球顶级舞者齐聚，展开街舞巅峰对决。全新赛制，更高水准，引爆街舞热潮。',
    content: '<p>《这就是街舞》第七季国际化程度再升级，不仅邀请了更多国际顶尖舞者参赛，还新增了跨国组队PK的新赛制。四位明星队长将带领各自战队，展开一场酣畅淋漓的街舞对决。</p><p>本季舞台设计更加炫酷，灯光效果达到演唱会级别，每一个表演都堪称视觉盛宴。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Street%20dance%20competition%20stage%20with%20dynamic%20dancers%20performing%2C%20colorful%20stage%20lighting%2C%20energetic%20atmosphere%2C%20urban%20dance%20culture%2C%20professional%20broadcast%20quality%2C%20exciting%20live%20show%20vibe&width=800&height=450&seq=heitao-v015&orientation=landscape',
    rating: 8.2,
    year: 2026,
    duration: '12期',
    tags: ['街舞', '竞技', '综艺', '舞蹈'],
    publishDate: '2026-06-15',
    viewCount: 11200000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v016',
    title: '毒液3：最后之舞',
    slug: 'du-ye-3-zui-hou-zhi-wu',
    category: 'dianying',
    categoryName: '电影',
    description: '埃迪和毒液面临迄今为止最大的威胁，一场关乎地球存亡的终极之战即将打响。',
    content: '<p>《毒液3：最后之舞》是毒液系列的终章之作。汤姆·哈迪回归饰演埃迪·布洛克，面对来自外星共生体军团的全面入侵，埃迪和毒液必须做出最终的选择。</p><p>本片在动作场面和特效上达到了系列最高水准，同时更加深入地探讨了埃迪与毒液之间复杂的关系。情感与视觉的双重冲击，为这个系列画上了圆满的句号。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20superhero%20movie%20scene%20with%20symbiote%20alien%20creature%20in%20urban%20night%20setting%2C%20dramatic%20action%20pose%2C%20rainy%20atmosphere%2C%20cinematic%20lighting%2C%20comic%20book%20movie%20aesthetic%2C%20intense%20and%20powerful&width=800&height=450&seq=heitao-v016&orientation=landscape',
    rating: 7.5,
    year: 2026,
    duration: '120分钟',
    tags: ['科幻', '动作', '漫威', '超级英雄'],
    publishDate: '2026-06-12',
    viewCount: 8900000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v017',
    title: '三体：黑暗森林',
    slug: 'san-ti-hei-an-sen-lin',
    category: 'dianshiju',
    categoryName: '电视剧',
    description: '面壁计划启动，四位面壁者各自秘密准备对抗三体文明。宇宙的黑暗森林法则即将揭晓。',
    content: '<p>《三体：黑暗森林》是《三体》系列电视剧的第二部，改编自刘慈欣同名科幻巨著。故事讲述了三体舰队正在向地球进发，人类启动了神秘的面壁计划，四位面壁者各自展开了对抗三体文明的秘密行动。</p><p>本季在科幻设定和视觉效果上全面升级，大量太空场景和未来科技的特效呈现达到了国产剧的新高度。演员阵容也进一步扩大，多位实力派演员加盟。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20scene%20with%20vast%20space%20fleet%20approaching%20Earth%2C%20dark%20cosmic%20background%2C%20futuristic%20technology%2C%20dramatic%20cinematic%20lighting%2C%20cold%20blue%20and%20silver%20tones%2C%20grand%20scale%2C%20mysterious%20atmosphere&width=800&height=450&seq=heitao-v017&orientation=landscape',
    rating: 9.0,
    year: 2026,
    duration: '30集',
    tags: ['科幻', '刘慈欣', '三体', '国产剧'],
    publishDate: '2026-06-10',
    viewCount: 31000000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'v018',
    title: '目中无人3',
    slug: 'mu-zhong-wu-ren-3',
    category: 'dianying',
    categoryName: '电影',
    description: '盲侠成乙再度出山，以一己之力对抗一整个黑暗势力，用拳脚捍卫心中正义。',
    content: '<p>《目中无人3》延续了前两部硬核武侠的风格，谢苗饰演的盲侠成乙再次登场。这一次，他卷入了一场涉及朝廷和江湖的惊天阴谋，以一己之力对抗整个黑暗势力。</p><p>本片的动作设计更加精彩纷呈，拳拳到肉的真功夫打斗场面令人血脉喷张。同时，故事也更加深入地挖掘了成乙这个角色的内心世界。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20film%20scene%20with%20swordsman%20in%20ancient%20village%20at%20dusk%2C%20dusty%20atmosphere%2C%20dramatic%20silhouette%2C%20wuxia%20aesthetic%2C%20warm%20golden%20light%2C%20action%20movie%20quality%2C%20intense%20mood&width=800&height=450&seq=heitao-v018&orientation=landscape',
    rating: 8.1,
    year: 2026,
    duration: '105分钟',
    tags: ['武侠', '动作', '谢苗', '国产片'],
    publishDate: '2026-06-08',
    viewCount: 6200000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v019',
    title: '拆弹专家4',
    slug: 'chai-dan-zhuan-jia-4',
    category: 'dianying',
    categoryName: '电影',
    description: '刘德华再度出演拆弹专家，面对前所未有的连环炸弹威胁，与时间赛跑拯救城市。',
    content: '<p>《拆弹专家4》由刘德华监制并主演，延续了系列一贯的高燃动作风格。本片中，香港遭遇了一场精心策划的连环炸弹袭击，拆弹专家潘乘风必须在有限时间内拆除散布在城市各处的炸弹。</p><p>影片在保持系列高水准动作场面的同时，加入了更多关于人性与牺牲的思考。每一场拆弹戏都紧张到让人窒息。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20action%20movie%20scene%20with%20bomb%20disposal%20expert%20in%20protective%20gear%2C%20tense%20urban%20setting%2C%20dramatic%20lighting%2C%20suspenseful%20atmosphere%2C%20blockbuster%20movie%20quality%2C%20high%20stakes%20situation&width=800&height=450&seq=heitao-v019&orientation=landscape',
    rating: 7.9,
    year: 2026,
    duration: '125分钟',
    tags: ['动作', '警匪', '刘德华', '港片'],
    publishDate: '2026-06-05',
    viewCount: 7800000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'v020',
    title: '大王别慌张2',
    slug: 'da-wang-bie-huang-zhang-2',
    category: 'duanju',
    categoryName: '短剧',
    description: '职场萌新误入妖怪山寨，与一群可爱搞笑的妖怪上演啼笑皆非的日常。',
    content: '<p>《大王别慌张2》延续了第一季轻松搞笑的风格，讲述了职场新人小玲在妖怪山寨中的爆笑日常。本季加入了更多新角色和更加离谱的剧情，笑点密集，一集接一集根本停不下来。</p><p>短小精悍的每集时长正好适合碎片时间观看，是通勤、午休的最佳伴侣。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20Chinese%20short%20comedy%20scene%20with%20quirky%20fantasy%20characters%20in%20traditional%20setting%2C%20colorful%20costumes%2C%20bright%20lighting%2C%20humorous%20expressions%2C%20playful%20atmosphere%2C%20lighthearted%20vibe&width=800&height=450&seq=heitao-v020&orientation=landscape',
    rating: 8.0,
    year: 2026,
    duration: '24集×8分钟',
    tags: ['短剧', '喜剧', '古装', '轻松'],
    publishDate: '2026-06-03',
    viewCount: 4500000,
    isHot: false,
    isNew: true,
  },
];

export function getVideosByCategory(slug: string): VideoArticle[] {
  return allVideos.filter((v) => v.category === slug);
}

export function getVideoById(id: string): VideoArticle | undefined {
  return allVideos.find((v) => v.id === id);
}

export function getVideoBySlug(slug: string): VideoArticle | undefined {
  return allVideos.find((v) => v.slug === slug);
}

export function getRelatedVideos(video: VideoArticle, limit: number = 4): VideoArticle[] {
  return allVideos
    .filter((v) => v.id !== video.id && v.category === video.category)
    .slice(0, limit);
}